import React, { useEffect, useState, useRef } from "react"
import useWindowResize from "@/hooks/useWindowResize"
import { isMobile, isTablet, withOrientationChange } from "react-device-detect"
import Button from "@/components/core/Button/Button"
import {
  getFilterEventInfo,
  getStoreEventInfo,
} from "@/components/FindStore/v1/analytics"
import _isEmpty from "lodash/isEmpty"
import { getConfig } from "@/constants/config"
import { getShortenedUrl, pushAnalyticsObjToDataLayer } from "@/utils/helper"
import { ReactBingmaps } from "react-bingmaps"
import AutoSuggestion from "@/components/core/AutoSuggestion/v1/AutoSuggestion"
import filterIcon from "@/public/icons/filter.svg"
import useIsSsr from "@/hooks/useIsSsr"
import StoreCard from "./StoreCard/StoreCard"
import cx from "classnames"
import Filter from "./Filter"
import StoreList from "./StoreList"
import { locationIconDataAnalytics } from "./analytics"
import ZipCodeInfoModal from "@/components/core/Modal/ZipCodeInfoModal"

const FindShowroomLanding = ({
  staticTexts,
  tabList,
  activeTab,
  findStoresBingKey,
  latitude,
  longitude,
  handleChange,
  searchTerm,
  citySuggestData,
  responseData,
  changeTab,
  findStoreDetails,
  handleFindStoreCheck,
  findStoreCheckedId,
  facets,
  selectedFilterCount,
  totalResults,
  getStoreDetails,
  getGeoLocation,
  ...props
}) => {
  const [width] = useWindowResize()
  const [showFilter, setShowFilter] = useState(false)
  const [showMap, setShowMap] = useState(false)
  const [tabList_] = useState(tabList?.filter(t => !t.inActive))
  const [FIRST_TAB, SECOND_TAB, THIRD_TAB] = [0, 1, 2]
  const [browseAllStoreUrl, setBrowseAllStoreUrl] = useState("")
  const [curStore, selectStore] = useState(null)
  const [center, setCenter] = useState([latitude, longitude])
  const [infoboxes, setInfoboxes] = useState([])
  const [mapInfo, setMapInfo] = useState([])
  const [showStoreCard, setShowStoreCard] = useState(false)
  const activeTabs = []
  const prevShowFilter = useRef(false)
  const isSsr = useIsSsr()
  const { isLandscape } = props

  const dataKeys =
    responseData?.length > 0 && responseData?.map(d => Object.keys(d))?.flat()

  const filterClass = cx({
    "find-store-landing__filter": true,
    "pl-0": isMobile ? false : !showFilter,
    "find-store-landing__filter--hide": !showFilter,
    "find-store-landing__filter--modal": isMobile ? showFilter : false,
  })
  useEffect(() => {
    if (responseData && responseData?.length > 0) {
      if (tabList_[activeTab].tabDetail) {
        if (responseData) {
          const handleCreateMapData = extractStores =>
            extractStores?.map(store => {
              return {
                location: [store.Latitude, store.Longitude],
                option: {
                  icon: `${process.env.NEXT_PUBLIC_AUTHORBASEURL}${tabList_[activeTab]?.icon}`,
                },
                addHandler: {
                  type: "click",
                  callback: () => handleClickLocationIcon(store),
                },
              }
            })
          const pins = []
          responseData.map(d => {
            for (const [k, v] of Object.entries(d)) {
              pins[k] = handleCreateMapData(v)
            }
          })
          if (pins[activeTab]) {
            setCenter([
              pins[activeTab][0]?.location[0],
              pins[activeTab][0]?.location[1],
            ])
          }
          setMapInfo(pins)
        } else {
          setMapInfo([])
        }
      }
    } else {
      setCenter([])
      setMapInfo([])
    }
    window.wow?.sync()
  }, [activeTab, responseData])

  useEffect(() => {
    if (showFilter) {
      const storeFilterEle = document.getElementById("kf-store-filter")
      if (storeFilterEle) {
        storeFilterEle?.childNodes &&
          storeFilterEle.childNodes[0]?.querySelector('[tabindex="0"]')?.focus()
      }
    }
    if (prevShowFilter?.current !== showFilter) {
      getFilterEventInfo(showFilter)
      prevShowFilter.current = showFilter
    }
  }, [showFilter])

  const handleClickLocationIcon = store => {
    setInfoboxes([
      {
        location: [store.Latitude, store.Longitude],
        option: { title: store.LocationName, description: store.AddressLine },
        addHandler: {
          type: "mouseenter",
          callback: () => {
            const closeIcon =
              document?.getElementsByClassName("infobox-close")[0]
            if (closeIcon) {
              closeIcon.addEventListener("click", () => setShowStoreCard(false))
            }
          },
        },
      },
    ])
    setCenter([store.Latitude, store.Longitude])
    selectStore(store)
    setShowStoreCard(true)
    locationIconDataAnalytics(store)
  }

  useEffect(() => {
    getConfig().then(async config => {
      const { general } = config
      const browseAllStoreUrl_ = await getShortenedUrl(
        staticTexts?.ctaLink || general?.allStoresPagePath || "/"
      )
      setBrowseAllStoreUrl(browseAllStoreUrl_)
    })
  }, [])
  useEffect(() => {
    if (!searchTerm) {
      getGeoLocation(staticTexts?.userMyLocation)
    }
  }, [])
  const handleTabChange = (tabIdx, type = null, title = null) => {
    changeTab(tabIdx)
    selectStore(null)
    setInfoboxes([])
    const eventInfo = JSON.parse(getStoreEventInfo(type, title))
    if (type || title) {
      pushAnalyticsObjToDataLayer(eventInfo)
    }
  }
  const handleKeyPress = e => {
    if (e.keyCode === 37 || e.keyCode === 39) {
      let tab
      if (e.keyCode === 37) {
        tab = activeTab - 1
      } else if (e.keyCode === 39) {
        tab = activeTab + 1
      }
      if (tab < 0) tab = tabList_.length - 1
      if (tab >= tabList_.length) tab = 0
      document
        .getElementById(`find-store__${tabList_[tab].key?.toLowerCase()}--tab`)
        .focus()
    }
  }

  return (
    <div className="find-store-landing">
      <ZipCodeInfoModal
        handleModalClose={() => {
          props.InfoModal()
        }}
        show={props.infoModal}
        data={props.infoModalError}
        store={true}
        labelledBy="Geo-Location-store-error-message"
        className="message-modal"
        staticTexts={{ ...staticTexts, continue: staticTexts.continue_ }}
      />
      <div className="row ml-0 mr-0">
        <div className="col-12">
          <nav
            id="find-store-crumb"
            className="find-store-landing__breadcrumb"
          ></nav>
          <div className={filterClass}>
            <div className="find-store-landing__filter-panel">
              {showFilter && (
                <Filter
                  facets={facets}
                  close={isShow => setShowFilter(isShow)}
                  onFilter={(curfilters, preventUnwantedDataLayer) =>
                    getStoreDetails(curfilters, preventUnwantedDataLayer)
                  }
                  displayShare={false}
                  texts={staticTexts}
                  selectedFilterCount={selectedFilterCount}
                  totalResults={totalResults}
                  showFilter={showFilter}
                  addToUrl={true}
                />
              )}
            </div>
          </div>
          <div
            className={`find-store-landing__result-container ${
              isMobile
                ? width >= 1024
                  ? showFilter
                    ? " "
                    : " find-store-landing__result-full"
                  : " col-12"
                : showFilter
                ? " "
                : " find-store-landing__result-full"
            }`}
          >
            <div className="row">
              <div
                className={`
                  find-store-landing__search-container ${
                    width <= 1024
                      ? showMap
                        ? isMobile && (isTablet || isLandscape)
                          ? "col-lg-5 col-5"
                          : "col-lg-12 col-12"
                        : "col-lg-12 col-12"
                      : "col-lg-5 col-5"
                  }`}
              >
                <div className="find-store-landing__search">
                  {!isSsr && (
                    <AutoSuggestion
                      placeholderLabel={staticTexts.countryPlaceholder}
                      selectedValue={searchTerm}
                      handleChange={selectedVal => handleChange(selectedVal)}
                      handleSelect={selectedVal => handleChange(selectedVal)}
                      optionList={citySuggestData}
                      borderValue={"bottom"}
                      suffix={
                        <img
                          role="button"
                          tabIndex="0"
                          aria-label={
                            showFilter
                              ? staticTexts.ariaLabel.hideFilter
                              : staticTexts.ariaLabel.showFilter
                          }
                          src={filterIcon?.src}
                          alt={staticTexts.ariaLabel.showFilter}
                          onClick={() => setShowFilter(!showFilter)}
                          id={"find-store-landing__search-auto-suggest"}
                        />
                      }
                    />
                  )}
                </div>
                <span
                  role="button"
                  tabIndex="0"
                  id="kf-store-use-location"
                  className="find-store-landing__use-location"
                  onClick={() => getGeoLocation(staticTexts.userMyLocation)}
                >
                  {staticTexts.userMyLocation}
                </span>
                {width <= 1025 ? (
                  !showMap ? (
                    <span
                      role="button"
                      tabIndex="0"
                      className="find-store-landing__view-list"
                      onClick={() => setShowMap(!showMap)}
                    >
                      {staticTexts.viewMap}
                    </span>
                  ) : (
                    <span
                      role="button"
                      tabIndex="0"
                      className="find-store-landing__view-list"
                      onClick={() => {
                        setShowMap(!showMap)
                        setShowStoreCard(false)
                      }}
                    >
                      {staticTexts.viewList}
                    </span>
                  )
                ) : (
                  ""
                )}
                <div className="find-store-landing__store-card --ml">
                  {curStore && showStoreCard && (
                    <StoreCard
                      isMobile={isMobile}
                      data={curStore}
                      store={
                        curStore?.DealerShowroom === "AS Showroom"
                          ? true
                          : false
                      }
                      staticTexts={staticTexts}
                      findStoreDetails={findStoreDetails}
                      handleFindStoreCheck={handleFindStoreCheck}
                      findStoreCheckedId={findStoreCheckedId}
                      isChecked={Boolean(findStoreCheckedId)}
                      activeTab={activeTab}
                      FIRST_TAB={FIRST_TAB}
                    />
                  )}
                </div>

                {!showMap && (
                  <React.Fragment>
                    {responseData &&
                      responseData?.length > 0 &&
                      !_isEmpty(searchTerm) && (
                        <div
                          className="find-store-landing__tabs wow animate__fadeInUp"
                          role="tablist_"
                        >
                          {tabList_.map((tab, i) => {
                            return !tab.inActive ? (
                              <button
                                key={i}
                                className={`find-store-landing__tab ${
                                  activeTab === i
                                    ? "find-store-landing__tab--active"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleTabChange(i, "inner tabs", tab.title)
                                }
                                onKeyDown={handleKeyPress}
                                role="tab"
                                tabIndex={0}
                                aria-selected={activeTab === i}
                                id={`find-store__${tab.key?.toLowerCase()}--tab`}
                              >
                                {tab.title}
                              </button>
                            ) : null
                          })}
                        </div>
                      )}
                    <div
                      role="list"
                      className={`find-store-landing__list ${
                        responseData && responseData.length > 0
                          ? "find-store-landing__show-list"
                          : ""
                      } ${
                        tabList_?.length > 0 &&
                        tabList_[activeTab]?.key !== staticTexts.kohlerStore
                          ? "find-store-landing__list-mb"
                          : ""
                      }`}
                    >
                      {responseData &&
                      responseData?.length > 0 &&
                      !_isEmpty(searchTerm) &&
                      responseData?.length > 0 ? (
                        responseData?.map(store => {
                          if (store[activeTab]?.length > 0) {
                            return store[activeTab].map((store, i) => (
                              <StoreList
                                data={store}
                                key={i}
                                index={i}
                                activeTab={activeTab}
                                staticTexts={staticTexts}
                                active={
                                  curStore?.EntityID === store.EntityID
                                    ? true
                                    : false
                                }
                                findStoreDetails={findStoreDetails}
                                handleFindStoreCheck={handleFindStoreCheck}
                                findStoreCheckedId={findStoreCheckedId}
                                isChecked={Boolean(findStoreCheckedId)}
                                FIRST_TAB={FIRST_TAB}
                                isMobile={isMobile}
                              />
                            ))
                          } else if (
                            dataKeys &&
                            !dataKeys.map(Number)?.includes(activeTab) &&
                            !activeTabs.includes(activeTab)
                          ) {
                            activeTabs.push(activeTab)
                            return (
                              <div
                                className={`find-store-landing__message find-store-landing__store-message`}
                              >
                                {staticTexts.locationErrormessage}
                              </div>
                            )
                          } else return null
                        })
                      ) : (
                        <div
                          className={`find-store-landing__message ${
                            !responseData?.length && responseData?.length > 0
                              ? "find-store-landing__store-message"
                              : ""
                          }`}
                        >
                          {staticTexts.locationErrormessage}
                        </div>
                      )}
                    </div>
                    {activeTab === FIRST_TAB && (
                      <div className="find-store-browseall-div">
                        <Button
                          label={
                            staticTexts.ctaLabel ?? staticTexts.browseAllStore
                          }
                          size="large"
                          type="ghost"
                          role="link"
                          tag="anchor"
                          target={staticTexts.isNewTab ? "_blank" : "_self"}
                          rel={staticTexts.isNewTab ? "noopener" : ""}
                          aria-label={staticTexts.ariaLabel.browseAll}
                          className="gbh-data-layer find-store-browseall-link"
                          useDefaultClass={true}
                          data-gbh-data-layer={getStoreEventInfo(
                            "browse all stores",
                            staticTexts.ctaLabel ?? staticTexts.browseAllStore,
                            browseAllStoreUrl
                          )}
                          to={browseAllStoreUrl}
                        />
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
              {
                <div
                  className={`find-store-landing__map ${
                    showMap
                      ? width <= 1024
                        ? isTablet || isLandscape
                          ? "col-7 find-store-landing__show-map"
                          : "col-12 find-store-landing__show-map"
                        : "col-7"
                      : "col-7"
                  } wow animate__fadeInUp`}
                >
                  {!_isEmpty(findStoresBingKey) && (
                    <ReactBingmaps
                      bingmapKey={findStoresBingKey}
                      center={center}
                      key={mapInfo[activeTab]}
                      mapTypeId={"grayscale"}
                      disableStreetside={true}
                      navigationBarMode={"square"}
                      zoom={12}
                      mapOptions={{
                        showMapTypeSelector: false,
                        NavigationBarMode: "square",
                      }}
                      infoboxes={infoboxes}
                      pushPins={mapInfo[activeTab]}
                    ></ReactBingmaps>
                  )}
                  <div className="find-store-landing__store-card">
                    {curStore && showStoreCard && (
                      <StoreCard
                        isMobile={isMobile}
                        data={curStore}
                        store={
                          curStore?.DealerShowroom === "AS Showroom"
                            ? true
                            : false
                        }
                        staticTexts={staticTexts}
                        findStoreDetails={findStoreDetails}
                        handleFindStoreCheck={handleFindStoreCheck}
                        findStoreCheckedId={findStoreCheckedId}
                        isChecked={Boolean(findStoreCheckedId)}
                        FIRST_TAB={FIRST_TAB}
                        activeTab={activeTab}
                      />
                    )}
                  </div>
                  {findStoresBingKey && (
                    <div
                      className="find-store-landing__location-note"
                      aria-label={staticTexts.ariaLabel.mapGuidelines}
                    >
                      {tabList_ &&
                        tabList_.map((tab, i) => (
                          <span key={i}>
                            <img
                              role="presentation"
                              aria-label={staticTexts.ariaLabel.mapMarker}
                              src={`${process.env.NEXT_PUBLIC_AUTHORBASEURL}${tab?.icon}`}
                              alt=""
                              className="img-fluid"
                            />
                            {isMobile
                              ? tab.locationNoteMobile
                              : tab.locationNote}
                          </span>
                        ))}
                    </div>
                  )}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withOrientationChange(FindShowroomLanding)
